import { createAsyncAction } from "typesafe-actions";
import { Client } from "../../models/client/Client";
import { ClientSubsidy } from "../../models/client/ClientSubsidy";
import { CardInfo } from "../../models/client/CardInfo";
import Coupon from "../../models/coupon/Coupon";
import { GetCardInfoActionTypes, GetClientActionTypes, GetClientCouponsActionTypes, GetClientSubsidiesActionTypes } from "./types";

export const getClientActions = createAsyncAction(
    GetClientActionTypes.REQUEST,
    GetClientActionTypes.SUCCESS,
    GetClientActionTypes.ERROR
)<undefined, Client, undefined>();

export const getClientCouponActions = createAsyncAction(
    GetClientCouponsActionTypes.REQUEST,
    GetClientCouponsActionTypes.SUCCESS,
    GetClientCouponsActionTypes.ERROR
)<undefined, Coupon[], undefined>();

export const getClientSubsidiesActions = createAsyncAction(
    GetClientSubsidiesActionTypes.REQUEST,
    GetClientSubsidiesActionTypes.SUCCESS,
    GetClientSubsidiesActionTypes.ERROR
)<undefined, ClientSubsidy[], undefined>();

export const getCardInfoActions = createAsyncAction(
    GetCardInfoActionTypes.REQUEST,
    GetCardInfoActionTypes.SUCCESS,
    GetCardInfoActionTypes.ERROR
)<string, CardInfo, undefined>();